import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { filter, find, includes, isEmpty, last, map, reverse } from 'lodash';
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardContent,
  Card,
  Grid,
  useMediaQuery,
  TableContainer,
  IconButton,
  Modal,
  createTheme,
  ThemeProvider,
  useTheme,
} from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { AiOutlineLogout } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { IoClose, IoImage } from 'react-icons/io5';
import { GiCheckMark } from 'react-icons/gi';
import { RxCross2, RxCrossCircled } from 'react-icons/rx';
import { MdDelete, MdFlipCameraIos, MdImageNotSupported } from 'react-icons/md';
import { toast } from 'react-toastify';
import { FaCameraRetro, FaLocationArrow } from 'react-icons/fa';
import fileUploadService from '../../services/fileUploadService';
import itemDeliveryService from '../../services/itemDeliveryService';
import stationupdateService from '../../services/stationupdateService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import moment from 'moment';
import { FaLocationDot } from 'react-icons/fa6';
import MUIDataTable from 'mui-datatables';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { ImageModal } from './SupervisorForm';
import { dataURLtoFile, getAddressFromCoords } from '../../common';

const Supervisor = () => {
  const navigate = useNavigate();
  const roles =
    localStorage?.getItem('roles') &&
    JSON?.parse(localStorage?.getItem('roles'));
  const webcamRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [id, setId] = useState('');
  const [capturePhoto, setCapturePhoto] = useState(false);
  const selectedDepartment = parseInt(localStorage?.getItem('department_id'));
  const [stations, setStations] = useState([]);
  // const [departments, setDepartments] = useState([]);
  const [stationUpdateList, setStationUpdateList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  // const [selectedDepartment, setSelectedDepartment] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [facingMode, setFacingMode] = useState('environment'); // Default to front camera
  const [photos, setPhotos] = useState([]); // Default to front camera
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSuccess = (position) => {
      const { latitude, longitude } = position.coords;
      setLocation({ latitude, longitude });
    };

    const handleError = (error) => {
      setError(error.message);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  }, []);

  const toggleCamera = () => {
    setFacingMode((prevMode) => (prevMode === 'user' ? 'environment' : 'user'));
  };

  // const fetchStations = async () => {
  //   const response = await itemDeliveryService.getItemDeliveriesDetails();
  //   setStations({
  //     resources: map(
  //       filter(
  //         response.data,
  //         (data) =>
  //           data?.department_id === selectedDepartment &&
  //           data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
  //           data?.allocated_qty !== 0
  //       ),
  //       (data) => {
  //         return {
  //           resource_name: data?.item_name,
  //           stock_available: false,
  //           stock_required: false,
  //           photo_url: '',
  //           station_name: localStorage?.getItem('department_name'),
  //         };
  //       }
  //     ),
  //   });
  // };

  // const fetchDepartment = () => {
  //   eventService?.getEventDetail()?.then((res) => {
  //     if (res?.status === 200) {
  //       setDepartments(
  //         filter(res?.data, {
  //           event_id: parseInt(localStorage?.getItem('event_id')),
  //         })
  //       );
  //     }
  //   });
  // };

  const fetchStationUpdate = () => {
    stationupdateService?.getStationUpdate()?.then((res) => {
      if (res?.status === 200) {
        setStationUpdateList(
          reverse(
            filter(res?.data, {
              event_id: parseInt(localStorage?.getItem('event_id')),
            })
          )
        );
      }
    });
  };

  const handleDelete = async (id) => {
    try {
      await stationupdateService?.deleteStationUpdate(id);
      fetchStationUpdate();
    } catch (error) {
      console.error('Error deleting station', error);
    }
  };

  useEffect(() => {
    // fetchDepartment();
    fetchStationUpdate();
  }, []);

  // useEffect(() => {
  //   if (selectedDepartment) {
  //     fetchStations();
  //   }
  // }, []);

  const handleCapturePhoto = async (setFieldValue, fieldName) => {
    // const imageSrc = webcamRef.current.getScreenshot();

    // const byteString = atob(imageSrc.split(',')[1]);
    // const mimeString = imageSrc.split(',')[0].split(':')[1].split(';')[0];
    // const ab = new ArrayBuffer(byteString.length);
    // const ia = new Uint8Array(ab);

    // for (let i = 0; i < byteString.length; i++) {
    //   ia[i] = byteString.charCodeAt(i);
    // }

    // const blob = new Blob([ab], { type: mimeString });

    // // Create a File from the Blob
    // const file = new File([blob], `photo_${Date.now()}.jpg`, {
    //   type: mimeString,
    // });
    // handleFileChange(file, setFieldValue, fieldName);

    const imageSrc = webcamRef.current.getScreenshot();

    const coords = await new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(
        (pos) => resolve(pos.coords),
        reject
      )
    );

    const address = await getAddressFromCoords(
      coords.latitude,
      coords.longitude
    );

    const img = new Image();
    img.src = imageSrc;
    img.onload = async () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');

      // Draw original photo
      ctx.drawImage(img, 0, 0);

      // Lines to display
      const lines = [
        address,
        `Lat: ${coords.latitude.toFixed(5)} | Lng: ${coords.longitude.toFixed(
          5
        )}`,
        new Date().toLocaleString(),
      ];

      ctx.font = isMobile ? '10px Arial' : '16px Arial';
      const padding = 10;
      const lineHeight = 18;

      // Map and text sizing
      const mapWidth = isMobile ? 140 : 200;
      const textWidth = canvas.width - mapWidth - padding * 3;
      const boxHeight = Math.max(lineHeight * lines.length + padding * 2, 100);
      const y = canvas.height - boxHeight;

      // Draw black background
      ctx.fillStyle = 'rgba(0,0,0,0.7)';
      ctx.fillRect(0, y, canvas.width, boxHeight);

      // Draw static map
      const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;
      const mapImg = new Image();
      mapImg.crossOrigin = 'Anonymous';
      mapImg.src = staticMapUrl;
      mapImg.onload = () => {
        const mapBottomPadding = 10; // extra space below map
        ctx.drawImage(
          mapImg,
          padding,
          y,
          mapWidth,
          boxHeight - mapBottomPadding
        );

        // Draw wrapped text on right
        ctx.fillStyle = 'white';
        ctx.textAlign = 'left';
        const textX = mapWidth + padding * 2;
        let textY = y + padding;

        lines.forEach((line) => {
          // Wrap long lines
          const words = line.split(' ');
          let lineText = '';
          words.forEach((word) => {
            const testLine = lineText + word + ' ';
            const metrics = ctx.measureText(testLine);
            if (metrics.width > textWidth) {
              ctx.fillText(lineText, textX, textY);
              lineText = word + ' ';
              textY += lineHeight;
            } else {
              lineText = testLine;
            }
          });
          ctx.fillText(lineText, textX, textY);
          textY += lineHeight;
        });

        // Export stamped image
        const stampedDataURL = canvas.toDataURL('image/jpeg');
        const stampedFile = dataURLtoFile(
          stampedDataURL,
          `photo_${Date.now()}.jpg`
        );
        handleFileChange(stampedFile, setFieldValue, fieldName);
      };
    };
  };

  const handleFileChange = async (file, setFieldValue, fieldName) => {
    const res = await fileUploadService?.handleFileUpload(file);
    if (res?.status === 200) {
      setPhotos(
        !isEmpty(photos)
          ? [...photos, res?.data?.filename]
          : [res?.data?.filename]
      );
      toast?.success('Photo captured successfully');
      // setFieldValue(
      //   fieldName,
      //   `https://verify360procam.pythonanywhere.com/static/images/${res?.data?.filename}`
      // );
      setCapturePhoto(false);
      setId(null);
    }
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  // return (
  //   <div>
  //     {/* <Box sx={{ mb: 3 }}>
  //         <FormControl fullWidth variant='outlined' sx={{ mb: 1 }}>
  //           <InputLabel id='department-label'>Select Department</InputLabel>
  //           <Select
  //             labelId='department-label'
  //             value={selectedDepartment}
  //             onChange={(e) => setSelectedDepartment(e.target.value)}
  //             label='Select Department'
  //           >
  //             {!isEmpty(departments) ? (
  //               map(departments, (option) => (
  //                 <MenuItem key={option?.id} value={option?.department_id}>
  //                   {option?.department_name}
  //                 </MenuItem>
  //               ))
  //             ) : (
  //               <MenuItem>No data found</MenuItem>
  //             )}
  //           </Select>
  //         </FormControl>
  //       </Box> */}
  //     {/* <LayoutContainer>
  //       <AdminHeader title='Station Update' />
  //       <div className='page-content-wrapper scrollable'>
  //         <TableContainer sx={{ overflowX: 'auto', mt: 2 }}>
  //           <Table>
  //             <TableHead className='tableHead'>
  //               <TableRow>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   SR No.
  //                 </TableCell>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   Time
  //                 </TableCell>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   Latitude
  //                 </TableCell>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   Longitude
  //                 </TableCell>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   Stock Available
  //                 </TableCell>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   Stock Required
  //                 </TableCell>
  //                 <TableCell
  //                   sx={{
  //                     padding: '4px 8px',
  //                     background: 'grey',
  //                     color: '#FFF',
  //                   }}
  //                 >
  //                   Photo
  //                 </TableCell>
  //               </TableRow>
  //             </TableHead>
  //             <TableBody className='tableBody'>
  //               {stationUpdateList?.map((station, index) => {
  //                 let photoList = [];
  //                 if (station?.photo_url) {
  //                   const sanitizedPhotoUrl = station.photo_url.replace(
  //                     /,\s*$/,
  //                     ''
  //                   );
  //                   try {
  //                     photoList = JSON.parse(sanitizedPhotoUrl);
  //                   } catch (error) {
  //                     console.error('Failed to parse photo_url:', station);
  //                   }
  //                 }
  //                 return (
  //                   <TableRow key={station.id}>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {index + 1}
  //                     </TableCell>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {station.submission_timestamp}
  //                     </TableCell>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {station.latitude}
  //                     </TableCell>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {station.longitude}
  //                     </TableCell>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {station.stock_available ? (
  //                         <GiCheckMark
  //                           style={{ color: '#06b806', strokeWidth: '1rem' }}
  //                           size={18}
  //                         />
  //                       ) : (
  //                         <RxCross2
  //                           style={{ color: 'red', strokeWidth: '0.08rem' }}
  //                           size={18}
  //                         />
  //                       )}
  //                     </TableCell>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {station.stock_required ? (
  //                         <GiCheckMark
  //                           style={{ color: '#06b806', strokeWidth: '1rem' }}
  //                           size={18}
  //                         />
  //                       ) : (
  //                         <RxCross2
  //                           style={{ color: 'red', strokeWidth: '0.08rem' }}
  //                           size={18}
  //                         />
  //                       )}
  //                     </TableCell>
  //                     <TableCell sx={{ padding: '0px 8px' }}>
  //                       {!isEmpty(photoList) ? (
  //                         map(photoList, (data) => {
  //                           return (
  //                             <Box
  //                               sx={{
  //                                 display: 'flex',
  //                                 fontSize: '0.8rem',
  //                                 alignItems: 'center',
  //                               }}
  //                             >
  //                               <IconButton
  //                                 sx={{ p: 0.4 }}
  //                                 onClick={() => {
  //                                   handleOpen();
  //                                   setImageUrl(data);
  //                                 }}
  //                               >
  //                                 <IoImage size={20} />
  //                               </IconButton>
  //                               {last(data?.split('/'))}
  //                             </Box>
  //                           );
  //                         })
  //                       ) : (
  //                         <IconButton sx={{ cursor: 'not-allowed' }}>
  //                           <MdImageNotSupported />
  //                         </IconButton>
  //                       )}
  //                     </TableCell>
  //                   </TableRow>
  //                 );
  //               })}
  //             </TableBody>
  //           </Table>
  //         </TableContainer>

  //         </div>
  //     </LayoutContainer>
  //     <ImageModal
  //       open={modalOpen}
  //       handleClose={handleClose}
  //       imageUrl={imageUrl}
  //     /> */}
  //   </div>
  // );

  const columns = [
    {
      name: 'station_name',
      label: 'STATION',
      options: {
        filter: true,
        sort: true,
        filterOptions: { fullWidth: true },
        customBodyRender: (value) => <span>{value}</span>,
      },
    },
    {
      name: 'stock_available',
      label: 'STOCK',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const stockRequired =
            stationUpdateList[tableMeta?.rowIndex]?.stock_required || false;

          return (
            <div style={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
              <div style={{ display: 'flex', gap: 1 }}>
                <span
                  style={{ color: '#333', fontSize: '0.675rem !important' }}
                >
                  AVAILABLE:
                </span>
                {value ? (
                  <IoMdCheckboxOutline fill='green' size={20} />
                ) : (
                  <RxCrossCircled
                    fill='red'
                    size={20}
                    style={{ color: 'red' }}
                  />
                )}
              </div>
              <div style={{ display: 'flex', gap: 1 }}>
                <span
                  style={{ color: '#333', fontSize: '0.675rem !important' }}
                >
                  REQUIRED:
                </span>
                {stockRequired ? (
                  <IoMdCheckboxOutline fill='green' size={20} />
                ) : (
                  <RxCrossCircled
                    fill='red'
                    size={20}
                    style={{ color: 'red' }}
                  />
                )}
              </div>
            </div>
          );
        },
      },
    },
    {
      name: 'submission_timestamp',
      label: 'TIME',
      options: {
        filter: false,
        sort: true, // Enable sorting
        customBodyRender: (value) => {
          // Format the timestamp for display
          return (
            <div>
              <span>{moment(value).format('DD/MM/YYYY')}</span>
              <span style={{ color: 'red' }}>
                {' '}
                {moment(value).format('HH:mm')}
              </span>
            </div>
          );
        },
        customSort: (data, direction) => {
          // Sort the data based on raw timestamp (not formatted)
          return data.sort((a, b) => {
            const timestampA = moment(a).valueOf(); // Convert to timestamp
            const timestampB = moment(b).valueOf(); // Convert to timestamp

            if (direction === 'asc') {
              return timestampA - timestampB; // Ascending order
            } else {
              return timestampB - timestampA; // Descending order
            }
          });
        },
      },
    },
    {
      name: 'location',
      label: 'LOCATION',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const location = stationUpdateList[tableMeta?.rowIndex];
          return (
            <div>
              {/* Location button with FaLocationArrow and text "Location" */}
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#007bff', // Customize background color as needed
                  color: 'white',
                  border: 'none',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  borderRadius: '5px',
                  fontSize: '0.675rem',
                }}
                onClick={() =>
                  window.open(
                    `https://www.google.com/maps?q=${location?.latitude},${location?.longitude}`,
                    '_blank'
                  )
                }
              >
                <FaLocationArrow
                  size={14}
                  color='white'
                  style={{ marginRight: '8px' }}
                />
                LOCATION
              </button>
            </div>
          );
        },
      },
    },
    {
      name: 'photo_url',
      label: 'PHOTO',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          let photoList = [];
          if (value) {
            const sanitizedPhotoUrl = value.replace(/,\s*$/, '');
            try {
              photoList = JSON.parse(sanitizedPhotoUrl);
            } catch (error) {
              console.error('Failed to parse photo_url:', value);
            }
          }
          return (
            <div style={{ display: 'flex' }}>
              {!isEmpty(photoList)
                ? map(photoList, (data) => (
                    <img
                      width={40}
                      height={40}
                      style={{
                        borderRadius: '4px',
                        cursor: 'pointer',
                        border: '1px solid #e0e0e0',
                      }}
                      src={`${process.env.REACT_APP_IMAGE_URL}/images/${data}`}
                      onClick={() => {
                        handleOpen();
                        setImageUrl(data);
                      }}
                      key={data}
                    />
                  ))
                : '-'}
            </div>
          );
        },
      },
    },
  ];

  const options = {
    expandableRows: false,
    download: false,
    filterOptions: 'fullWidth',
    selectableRows: 'none',
    print: false,
    rowsPerPageOptions: [30, 50, 100],
    rowsPerPage: 30,
    tableBodyHeight: 'calc(100vh - 13rem)',
    viewColumns: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  const getMuiTheme = () =>
    createTheme({
      components: {
        MUIDataTable: {
          styleOverrides: {
            root: {
              boxShadow: 'none',
              backgroundColor: '#FFF',
            },
          },
        },
        MUIDataTableHeadCell: {
          styleOverrides: {
            root: {
              backgroundColor: '#2F3542', // Keep background as you have it
              color: '#fff !important', // Ensure heading text is white
              border: 'none',
              fontWeight: '550 !important',
              '&:nth-last-of-type(1)': {
                borderTopRightRadius: '1rem',
                // borderBottomRightRadius: '0.2rem',
              },
            },
            sortActive: {
              color: '#fff !important', // Active sort icon color should also be white
            },
            sortAction: {
              '& .MuiTableSortLabel-icon': {
                color: '#fff !important', // Ensure sort icon stays white when active
              },
            },
            toolButton: {
              fontWeight: 'bold',
              fontSize: '0.675rem !important',
              paddingTop: '3px',
              paddingBottom: '3px',
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              padding: '2px 8px 2px 8px',
            },
          },
        },
        MuiTablePagination: {
          styleOverrides: {
            root: {
              backgroundColor: '#FFFFFF',
              height: '40px',
            },
            select: {
              backgroundColor: '#FFFFFF',
            },
            actions: {
              backgroundColor: '#FFFFFF',
            },
          },
        },
        MUIDataTableSelectCell: {
          styleOverrides: {
            headerCell: {
              border: 'none',
              borderTopLeftRadius: '0.2rem',
              borderBottomLeftRadius: '0.2rem',
              backgroundColor: '#2F3542',
              '& .MuiCheckbox-root': {
                color: '#fff',
                padding: '4px',
              },
            },
          },
        },
        MuiToolbar: {
          styleOverrides: {
            root: {
              minHeight: '30px!important',
              padding: '0px!important',
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              padding: '4px',
            },
          },
        },
        MUIDataTableBodyRow: {
          styleOverrides: {
            root: {
              '&:nth-of-type(even)': {
                backgroundColor: '#EAF3FF',
              },
              '&:nth-of-type(odd)': {
                backgroundColor: '#FFF',
              },
              '& td': {
                textAlign: 'left', // Center align body text data
                border: 'none',
              },
              marginBottom: '10px',
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              color: '#fff',
              padding: '6px 4px !important',
              fontWeight: '550 !important',
              fontSize: '0.675rem !important',
              justifyContent: 'start !important',
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            root: {
              padding: '10px 12px !important',
              fontSize: '0.675rem',
            },
          },
        },
        MUIDataTableBodyCell: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
            },
          },
        },
        MuiPopover: {
          styleOverrides: {
            paper: {
              minWidth: '300px !important', // Increase the width of filter dropdown
              padding: '10px', // Add padding inside the dropdown
              borderRadius: '8px', // Optionally, round the corners
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)', // Add a subtle shadow for better visibility
              backgroundColor: '#fff', // Background color (you can change it)
            },
          },
        },
        MuiMenu: {
          styleOverrides: {
            paper: {
              minWidth: '250px  !important',
              maxHeight: '200px',
              overflowY: 'auto',
            },
          },
        },
        MuiMenuItem: {
          styleOverrides: {
            root: {
              fontSize: '0.675rem !important',
              fontWeight: 500,
              color: '#333',
              padding: '8px 16px',
              '&:hover': {
                backgroundColor: '#F5F5F5',
              },
            },
          },
        },
        MuiSelect: {
          styleOverrides: {
            select: {
              fontSize: '0.675rem !important',
              padding: '6px 10px',
            },
          },
        },
      },
    });

  return (
    <>
      <LayoutContainer>
        <AdminHeader title='SUPERVISOR UPDATES' />
        <div style={{ padding: '1rem 3rem' }}>
          {/* <div className='page-content-wrapper scrollable'> */}
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              data={stationUpdateList}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </div>
        {/* <TableContainer
            sx={{ overflowX: 'auto', backgroundColor: '#f9f9f9' }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      padding: '10px',
                      backgroundColor: '#2F3542',
                      fontWeight: 700,
                      color: '#fff',
                      // textAlign: 'center',
                      borderBottom: '2px solid #e0e0e0',
                    }}
                  >
                    Station
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: '10px',
                      backgroundColor: '#2F3542',
                      fontWeight: 700,
                      pl: 2.3,
                      color: '#fff',

                      borderBottom: '2px solid #e0e0e0',
                    }}
                  >
                    Stock
                  </TableCell>

                  <TableCell
                    sx={{
                      padding: '10px',
                      backgroundColor: '#2F3542',
                      fontWeight: 700,
                      color: '#fff',
                      pl: 2.3,

                      borderBottom: '2px solid #e0e0e0',
                    }}
                  >
                    Time
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: '10px',
                      backgroundColor: '#2F3542',
                      fontWeight: 700,
                      color: '#fff',
                      borderBottom: '2px solid #e0e0e0',
                    }}
                  >
                    Location
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: '10px',
                      backgroundColor: '#2F3542',
                      fontWeight: 700,
                      color: '#fff',
                      textAlign: 'center',
                      borderBottom: '2px solid #e0e0e0',
                    }}
                  >
                    Photo
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stationUpdateList?.map((station, index) => {
                  let photoList = [];
                  if (station?.photo_url) {
                    const sanitizedPhotoUrl = station.photo_url.replace(
                      /,\s*$/,
                      ''
                    );
                    try {
                      photoList = JSON.parse(sanitizedPhotoUrl);
                    } catch (error) {
                      console.error('Failed to parse photo_url:', station);
                    }
                  }
                  return (
                    <TableRow
                      key={station.id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                      }}
                    >
                      <TableCell>{station.station_name}</TableCell>
                      <TableCell>
                        <div
                          style={{
                            display: 'flex',

                            gap: 1,
                          }}
                        >
                          <span
                            style={{
                              color: '#333',
                              fontSize: '12px',
                            }}
                          >
                            Available :
                          </span>
                          {station.stock_available ? (
                            <GiCheckMark
                              style={{ color: '#06b806' }}
                              size={14}
                            />
                          ) : (
                            <RxCross2
                              style={{
                                color: 'red',
                              }}
                              size={14}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            display: 'flex',

                            gap: 1,
                          }}
                        >
                          <span style={{ color: '#333', fontSize: '12px' }}>
                            Required:
                          </span>
                          {station.stock_required ? (
                            <GiCheckMark
                              style={{ color: '#06b806' }}
                              size={14}
                            />
                          ) : (
                            <RxCross2
                              style={{
                                color: 'red',
                              }}
                              size={14}
                            />
                          )}
                        </div>
                      </TableCell>
                      <TableCell>
                        {' '}
                        <span>
                          {moment(station.submission_timestamp)?.format(
                            'DD/MM/YYYY'
                          )}
                        </span>
                        <span style={{ color: 'red' }}>
                          {' '}
                          {moment(station.submission_timestamp)?.format(
                            'HH:mm'
                          )}
                        </span>
                      </TableCell>
                      <TableCell>
                        {
                          <FaLocationDot
                            fill='green'
                            size={20}
                            cursor={'pointer'}
                            onClick={() =>
                              window.open(
                                `https://www.google.com/maps?q=${station?.latitude},${station?.longitude}`,
                                '_blank'
                              )
                            }
                          />
                        }
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: '10px',
                          textAlign: 'center',
                        }}
                      >
                        <div
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          {!isEmpty(photoList)
                            ? map(photoList, (data) => (
                                <img
                                  width={40}
                                  height={40}
                                  style={{
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    border: '1px solid #e0e0e0',
                                  }}
                                  src={`${process.env.REACT_APP_IMAGE_URL}/images/${data}`}
                                  onClick={() => {
                                    handleOpen();
                                    setImageUrl(data);
                                  }}
                                  key={data}
                                />
                              ))
                            : '-'}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer> */}
        {/* <Table className='table'>
            <TableHead className='tableHead'>
              <TableRow>
                <TableCell> SR No.</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Latitude</TableCell>
                <TableCell>Longitude</TableCell>
                <TableCell>Stock Available</TableCell>
                <TableCell>Stock Required</TableCell>
                <TableCell>Photo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className='tableBody'>
              {stationUpdateList.map((station, index) => {
                let photoList = [];
                if (station?.photo_url) {
                  const sanitizedPhotoUrl = station.photo_url.replace(
                    /,\s*$/,
                    ''
                  );
                  try {
                    photoList = JSON.parse(sanitizedPhotoUrl);
                  } catch (error) {
                    console.error('Failed to parse photo_url:', station);
                  }
                }
                return (
                  <TableRow key={station.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{station.station_name}</TableCell>
                    <TableCell>{station.latitude}</TableCell>
                    <TableCell>{station.longitude}</TableCell>
                    <TableCell>{station.stock_available}</TableCell>
                    <TableCell>{station.required}</TableCell>
                    <TableCell>
                      {!isEmpty(photoList) ? (
                        map(photoList, (data) => {
                          return (
                            <Box
                              sx={{
                                display: 'flex',
                                fontSize: '0.8rem',
                                alignItems: 'center',
                              }}
                            >
                              <IconButton
                                sx={{ p: 0.4 }}
                                onClick={() => {
                                  console.log('datadata', data);
                                  handleOpen();
                                  setImageUrl(data);
                                }}
                              >
                                <IoImage size={20} />
                              </IconButton>
                              {last(data?.split('/'))}
                            </Box>
                          );
                        })
                      ) : (
                        <IconButton sx={{ cursor: 'not-allowed' }}>
                          <MdImageNotSupported />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table> */}
        {/* </div> */}
      </LayoutContainer>
      {modalOpen && (
        <ImageModal
          open={modalOpen}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </>
  );
};

export default Supervisor;

// export const ImageModal = ({ open, handleClose, imageUrl }) => {
//   if (!imageUrl) {
//     // Optionally handle the case where imageUrl is not provided
//     return <div>No image available</div>;
//   }

//   return (
//     <Modal
//       open={open}
//       onClose={handleClose}
//       aria-labelledby='image-modal-title'
//       aria-describedby='image-modal-description'
//     >
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           height: '100%',
//           overflow: 'auto',
//           backgroundColor: 'rgba(0, 0, 0, 0.4)',
//           position: 'relative',
//           padding: 2,
//         }}
//       >
//         <IconButton
//           onClick={handleClose}
//           sx={{
//             position: 'absolute',
//             top: 16,
//             right: 16,
//             color: 'white',
//           }}
//         >
//           <IoClose size={24} />
//         </IconButton>
//         <img
//           src={`${process.env.REACT_APP_IMAGE_URL}/images/${imageUrl}`}
//           alt='Station'
//         />
//       </Box>
//     </Modal>
//   );
// };
